import { getCommonOption } from '../http'


const getCommonOptionToGlobalConfig = async (query) => {
  const { terminalType } = query
  if (window?.__$ynf?.globalConfig?.commonOption) {
    return
  }
  const commonOption = await getCommonOption(terminalType)
  window.__$ynf.globalConfig.commonOption = commonOption
}

export const initGlobalConfig = async (query) => {
  if (!window.__$ynf) {
    window.__$ynf = { globalConfig: {} }
  }
  await getCommonOptionToGlobalConfig(query)
}
